import type { JSX } from 'react';
import type { TextProps } from '../Text';
import { Text } from '../Text';

export type DataListItemValueProps = TextProps;

/**
 * The value of the `DataListItem`. Extends the [Text]() component.
 */
export const DataListItemValue = (props: DataListItemValueProps): JSX.Element => {
  return (
    <Text
      variant="body3"
      {...props}
      renderAs="dd"
    />
  );
};

DataListItemValue.displayName = 'DataListItemValue';
